var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4465 4.4032L25.2215 10.1665C26.1315 11.0882 26.1315 12.5582 25.2215 13.4799L14.4999 24.2015C13.623 25.075 12.4358 25.5654 11.1982 25.5654C9.96057 25.5654 8.77337 25.075 7.89654 24.2015L3.7782 20.0832C2.8682 19.1615 2.8682 17.6915 3.7782 16.7699L16.1449 4.4032C17.0665 3.4932 18.5365 3.4932 19.4465 4.4032ZM5.4232 18.4265L9.5532 22.5449C10.4632 23.4665 11.9332 23.4665 12.8549 22.5449L16.9732 18.4265L11.1982 12.6515L5.4232 18.4265Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErase);
export default __webpack_public_path__ + "static/media/erase.9d1ea793b1bbe96b87e821700bccf8b2.svg";
export { ForwardRef as ReactComponent };